import React from "react";
import video from "../../images/market.mp4";
import "./vision.css";

const Vision = () => {
  return (
    <section className="vision-section">
      <div className="vision-inner">
        <p className="vision-kicker">
          <span className="vision-kicker__line" />
          OUR VISION
          <span className="vision-kicker__line" />
        </p>

        <h2 className="vision-title">
          Building a <span>Better Tomorrow</span>
        </h2>

        <div className="vision-video-wrap">
          <video controls preload="metadata">
            <source src={video} type="video/mp4" />
          </video>
        </div>
      </div>
    </section>
  );
};

export default Vision;
